import styled from "@emotion/styled";
import { Button, Chip, Stack } from "@mui/material";

export const LoanForm = styled.div`
  background: #f4f8fb;
  * {
    font-family: "Satoshi", "NeurialGrotesk-Variable", -apple-system,
      BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
      "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  }
`;

export const LoanFormHeader = styled.div`
  background: #000154;
  padding: 26px 15px;
  .logo {
    font-size: 0px;
    flex: 1;
    img {
      display: inline-block;
    }
  }
  .headerContent {
    color: #fff;
    font-size: 28px;
    font-weight: 500;
  }
  .container {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    align-items: center;
  }
  margin-bottom: 50px;
  *:before,
  *:after {
    content: none;
  }
`;

export const LoanFormContent = styled.div`
  .container {
    background: rgb(255, 255, 255);
    padding: 32px;
    border-radius: 10px;
  }
`;
export const LoanFormSection = styled.div`
  padding-bottom: 32px;
  label.form-label {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .flag-dropdown {
    border: none !important;
    background: none !important;
  }
  .form-input-desc-error {
    margin-top: 10px;
  }
  .form-control,
  .MuiOutlinedInput-notchedOutline {
    border: none !important;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-size: 12px;
    color: #222;
    font-weight: 700;
    &::-webkit-input-placeholder,
    &::-moz-placeholder,
    &:-ms-input-placeholder,
    &::-ms-input-placeholder,
    &::placeholder {
      color: #888;
      opacity: 1 !important;
      font-weight: 700;
    }
  }
  input.MuiInputBase-input {
    color: #222;
    font-weight: 700;
    font-size: 12px !important;
    &::-webkit-input-placeholder,
    &::-moz-placeholder,
    &:-ms-input-placeholder,
    &::-ms-input-placeholder,
    &::placeholder {
      color: #888;
      opacity: 1 !important;
      font-weight: 700;
    }
  }
`;
export const LoanFormSectionHead = styled.div`
  background: #fef5f8;
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  margin-bottom: 32px;
  border-radius: 10px;
  color: #ed0057;
  align-items: center;
  .title {
    flex: 1;
    font-size: 20px;
    font-weight: 500;
  }
  svg {
    font-size: 20px;
  }
`;
export const SubmitBtnStyled = styled(Button)`
  background: #000154 !important;
  font-size: 32px;
  min-height: 70px;
  color: #fff;
  border-radius: 10px;
  padding: 5px 35px;
  opacity: 1 !important;
  &:disabled {
    background: #cccccc !important;
    color: #666666;
    cursor: not-allowed;
    opacity: 0.6 !important;
    pointer-events: none !important;
    display: block !important;
  }
`;
export const LoanFormThankYou = styled(Stack)`
  background-color: #f4f8fb;
  * {
    font-family: "Satoshi", "NeurialGrotesk-Variable", -apple-system,
      BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
      "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  }
`;
export const FilesStyled = styled(Chip)`
  background: #f8ffef;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  font-size: 12px;
  color: #888888;
  font-weight: 700;
  margin-top: 10px;
  margin-right: 10px;
`;
export const UploadSection = styled.div`
  .uploadWrap {
    display: flex;
    gap: 30px;
    align-items: flex-start;
    &:before,
    &:after {
      content: none;
    }
    .right {
      flex: 1;
    }
  }
  .uploadCapsule {
    max-width: 125px;
  }
  .upload {
    position: relative;
    img {
      display: block;
    }
    input {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
  .content {
    ul {
      margin: 0;
      li {
        margin: 0 !important;
        margin-bottom: 5px !important;
        color: #888888;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
`;
